export default __webpack_public_path__ + "a1f3846a1da9e576d5eaae923f93977c.svg";